import { Route, Routes } from 'react-router-dom'
import HomePage from '../page/home'
import { CallbackPage } from '../page/callback'
import LogoutPage from '../page/logout'
import Layout from '../components/Layout'
import SSHKeyPage from '../page/sshkey'
import VMPage from '../page/vm'
import PricingPage from '../page/pricing'
import TicketListPage from '../page/tickets'
import TicketPage from '../page/tickets/ticket'
import OdooPage from '../page/odoo'
import RoleAssignmentPage from '../page/role'
import BillingSuccessfulPage from '../page/billing/successful'
import BillingCancelPage from '../page/billing/cancel'
import S3Page from '../page/s3'
import MicroAlgaePage from '../page/microalgae'
import BillingPage from '../page/invoice'
import AdminPage from '../page/admin'

const authRoutes = [
    {
        path: '/',
        element: <HomePage />,
    },
    {
        path: '/microalgae',
        element: <MicroAlgaePage />,
    },
    {
        path: '/vm',
        element: <VMPage />,
    },
    {
        path: '/odoo',
        element: <OdooPage />,
    },
    {
        path: '/s3',
        element: <S3Page />,
    },
    {
        path: '/sshkey',
        element: <SSHKeyPage />,
    },
    {
        path: '/role',
        element: <RoleAssignmentPage />,
    },
    {
        path: '/pricing',
        element: <PricingPage />,
    },
    {
        path: '/tickets',
        element: <TicketListPage />,
    },
    {
        path: '/ticket/:id',
        element: <TicketPage />,
    },
    {
        path: '/billing',
        element: <BillingPage />,
    },
    {
        path: '/billing/successful',
        element: <BillingSuccessfulPage />,
    },
    {
        path: '/billing/cancel',
        element: <BillingCancelPage />,
    },
    {
        path: '/admin',
        element: <AdminPage />,
    },
    {
        path: '/logout',
        element: <LogoutPage />,
    },
    {
        path: '/callback',
        element: <CallbackPage />,
        noAuth: true,
    },
]

export default function Router() {
    return (
        <Layout>
            <Routes>
                {authRoutes.map((route) => (
                    <Route
                        key={route.path}
                        path={route.path}
                        element={route.element}
                    />
                ))}
            </Routes>
        </Layout>
    )
}
